import { CSSProperties, ReactNode } from 'react';

type MaxWidthProps = {
    children: ReactNode;
    width: CSSProperties['maxWidth'];
    inline?: boolean;
};

const MaxWidth = ({ children, width, inline = false }: MaxWidthProps) => {
    return (
        <span
            style={{
                width: '100%',
                maxWidth: width,
                display: inline ? 'inline-block' : 'block',
            }}
        >
            {children}
        </span>
    );
};

export default MaxWidth;
